<template>
  <div class="layout">
    <div class="layout-wrapper">
      <!--头部-->
      <div class="layout-header">
        <div class="layout-left">
          <img class="logo" :src="schoolLogo"/>
          <p class="name">{{schoolName}}</p>
          <p class="line"></p>
          <p class="info">校园信息发布系统</p>
        </div>
        <div class="layout-right">
          <ul class="nav">
            <li @click="goToHome">首页</li>
          </ul>
          <div class="line"></div>
          <div class="person">
            <img class="pic" :src="userIcon"/>
            <p>{{userName}}</p>
          </div>
          <div class="line"></div>
          <div class="quit" @click="logout">
            <img class="pic" src="/static/quit.png"/>
            <p>退出</p>
          </div>
        </div>
      </div>

      <!--导航-->
      <div class="layout-nav">
        <ul class="nav">
          <router-link tag="li" to="/article" class="active">文章管理</router-link>
        </ul>
        <ul class="breadcrumb">
          <li><a @click="goToHome" style="cursor: pointer">首页</a><span class="separator">/</span></li>
          <li><router-link to="/article">校园信息发布系统</router-link><span class="separator">/</span></li>
          <li>{{ currentRouter.name }}</li>
        </ul>
      </div>

      <!--内容-->
      <div class="layout-content">

        <!-- 遮罩层 -->
        <div class="el-loading-mask" v-show="loading">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
            <p class="el-loading-text">拼命加载中</p>
          </div>
        </div>
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import {getCookie, goToHome, clearAllCookie} from 'common/js/cookie'
import {mapGetters} from 'vuex'
export default {
  name: 'layout',
  computed: {
    ...mapGetters([
      'loading'
    ]),
    currentRouter () { // 当前路由
      return this.$route
    }
  },
  data () {
    return {
      schoolLogo: '',
      schoolName: '',
      userIcon: '',
      userName: ''
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    goToHome () {
      goToHome()
    },
    // 获取学校信息和用户信息
    init () {
      this.schoolLogo = getCookie('schoolLogo')
      this.schoolName = getCookie('schoolName')
      this.userIcon = getCookie('userIcon')
      this.userName = getCookie('userName')
    },
    logout () {
      this.$confirm('确认退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearAllCookie()
        this.$message({
          type: 'success',
          message: '退出成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消退出'
        })
      })
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import "./../../common/stylus/variable.styl"
  @import "./../../common/stylus/mixin.styl"
  .layout
    width 100%
    height 100%
    .layout-wrapper
      box-column()
      position relative
      width 100%
      height 100%
      overflow hidden
      background $color-background
      .layout-header
        flex 0 0 0.5rem
        height .5rem
        box()
        padding 0 .3rem
        background linear-gradient(#1a90ff, #0079ed)
        .layout-left
          flex 0 0 3.5rem
          box()
          font-size $font-size-medium
          .logo
            margin-right .1rem
            width .32rem
            height .32rem
            border-radius .06rem
          .name
            color #eaf3fc
          .info
            font-size $font-size-small
            color #b9dbfd
        .layout-right
          flex 1.0
          box-end()
          .nav
            box()
            &>li
              // width .9rem
              text-align center
              font-size $font-size-small
              color #b9dbfd
              cursor pointer
              &.active
                font-size $font-size-medium
                color #ffffff
          .person
            box()
            font-size $font-size-small
            color #b9dbfd
            .pic
              margin-right .1rem
              width .32rem
              height .32rem
              border-radius 50%
          .quit
            box()
            font-size $font-size-small
            color #b9dbfd
            cursor pointer
            .pic
              margin-right .05rem
              width .15rem
        .line
          margin 0 .1rem
          width 1px
          height .15rem
          background #eaf3fc
      .layout-nav
        flex 0 0 0.4rem
        height .4rem
        margin-bottom .01rem
        padding 0 .3rem
        box-between()
        box-shadow 0 .01rem .08rem 0 rgba(0, 0, 0, 0.2)
        overflow hidden
        .nav
          box()
          &>li
            width .84rem
            line-height .4rem
            font-size $font-size-small
            text-align center
            color #333333
            cursor pointer
            &.active
              line-height .4rem
              background #fff
              color $color-theme
              border-bottom 1px solid $color-theme
              box-sizing border-box
              transition all .3s ease
        .breadcrumb
          box()
          &>li
            font-size $font-size-small-x
            color #333333
            &>a
              font-size $font-size-small-x
              color #333333
              &:hover
                color $color-theme
            .separator
              margin 0 .02rem
            &:last-child
              color $color-theme
      .layout-content
        position relative
        flex 1.0
        overflow-y auto
        padding .1rem .3rem
</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue